import React, {useContext} from 'react';
import {KatAccordion, KatBox} from "@amzn/katal-react";
import {GlobalContext} from "src/context/GlobalProvider";
import {generateSectionEventsMap} from "src/common/utils/eventsUtil";
import {Section} from "src/components/healthDashboard/Section";
import {IEvent} from "src/context/models/Event";
import {IOperationMetadata, ISectionMetadata} from "src/context/models/Metadata";
import {ISectionItem, ISections} from "src/context/models/Section";
import {useTranslation} from "react-i18next";

type Props = {
    sections: ISections,
    metadata: ISectionMetadata | null,
    events: IEvent[]
};

export const CurrentStatus: React.FC<Props> = ({
                                                   sections,
                                                   metadata,
                                                   events
                                               }) => {
    const {t} = useTranslation();
    const {sessionState} = useContext(GlobalContext);
    const region = sessionState.data.region;

    const populateSections = (sections: ISections, metadata: ISectionMetadata | null, events: IEvent[]) => {
        const sectionMetadataMap: Map<string, IOperationMetadata[]> = new Map<string, IOperationMetadata[]>();
        metadata?.metadata.forEach(item => sectionMetadataMap.set(item.name, item.operations))
        const sectionEventsMap: Map<string, IEvent[]> = generateSectionEventsMap(events, region);

        return (
            <KatAccordion id="sections">
                {sections.sections
                    .sort(((a, b) => ('' + a.name).localeCompare(b.name)))
                    .map((section: ISectionItem) =>
                    <Section key={section.name} section={section} sectionEventsMap={sectionEventsMap}
                             sectionMetadataMap={sectionMetadataMap}/>
                )}
            </KatAccordion>
        )
    };

    return (
        <>
            <KatBox id="current-status" variant="azure">
                <h2>
                    {t("Current Status")}
                </h2>
                {populateSections(sections, metadata, events)}
            </KatBox>
        </>
    );
}
